// @flow
import { useContext } from 'react';
import {
  convertArrayToMapByProperties,
  convertObjectOfKeyAndArrayToMapWithSetValues,
} from '@src/common-utils/utils';
import {
  getMetricNameToAggregatedUsageMapForKafkaMetrics,
  getMetricUsageMapWithOnlyNonZeroValuesAndNonEmptyMetricObjects,
  getMetricUsageMapWithZeroUsageForUnsizedKafkaGuidanceKeys,
} from '@components/custom-discounts/mld-for-field/utils';

import { EstimateContext } from '../contexts/EstimateContext';

import { useIsCCStarterCommitSelected } from './useIsCCStarterCommitSelected';

export const useEstimateMLDForFieldGuidance = () => {
  const estimate = useContext(EstimateContext);
  const isCCStarterCommitSelected = useIsCCStarterCommitSelected();

  const {
    usages = [],
    ae_discount_guidance: aeDiscountGuidance = [],
    connector_tier_mapping: connectorTierMapping,
  } = estimate?.mld_guidance || {};

  const metricNameToUsagesMapBeforeFilteringOutZeroValues = convertArrayToMapByProperties(
    usages,
    'metric_name',
    'dimension_combination_usages'
  );

  const metricNameToUsagesMapWithOnlyNonZeroValues =
    getMetricUsageMapWithOnlyNonZeroValuesAndNonEmptyMetricObjects(
      metricNameToUsagesMapBeforeFilteringOutZeroValues
    );

  const metricNameToAEDiscountGuidanceMap = convertArrayToMapByProperties(
    aeDiscountGuidance,
    'metric',
    'guidance'
  );

  // A CC Starter Commit generates its Kafka discounts for every dimension up front, so unlike a regular
  // estimate a non-admin must be able to edit them before anything is sized (up to the no sizing ceiling).
  const metricNameToUsagesMap = isCCStarterCommitSelected
    ? getMetricUsageMapWithZeroUsageForUnsizedKafkaGuidanceKeys(
        metricNameToUsagesMapWithOnlyNonZeroValues,
        metricNameToAEDiscountGuidanceMap
      )
    : metricNameToUsagesMapWithOnlyNonZeroValues;

  const metricNameToAggregatedUsageMapBasedOnGuidanceForKafkaMetrics =
    getMetricNameToAggregatedUsageMapForKafkaMetrics(
      metricNameToUsagesMap,
      metricNameToAEDiscountGuidanceMap
    );

  const connectTierMappingMap = convertObjectOfKeyAndArrayToMapWithSetValues(connectorTierMapping);

  return {
    metricNameToUsagesMap,
    metricNameToAEDiscountGuidanceMap,
    connectTierMappingMap,
    metricNameToAggregatedUsageMapBasedOnGuidanceForKafkaMetrics,
  };
};
